import { LogoIconType } from '@ui-components/global/ComponentProps'
import { SimpleStep } from '@ui-components/layout/SimpleStep'
import { PrimaryTopBarActionButtonOptions } from '@ui-components/navigation/PrimaryTopBar/types'
import { JSX } from 'react'
import { useIntl } from 'react-intl'

import { TransitionLoadingIndicator } from '../../components/TransitionLoadingIndicator'

interface SimpleTransitionStepProps {
  icon?: LogoIconType
  onAbort?: () => void
}

export const SimpleTransitionStep = ({ icon = LogoIconType.SOK, onAbort }: SimpleTransitionStepProps): JSX.Element => {
  const intl = useIntl()
  const actionButtonOptions: PrimaryTopBarActionButtonOptions | undefined = onAbort
    ? { label: intl.formatMessage({ id: 'common-exit' }), onClick: onAbort }
    : undefined

  return (
    <SimpleStep icon={icon} actionButtonOptions={actionButtonOptions}>
      <TransitionLoadingIndicator />
    </SimpleStep>
  )
}
